import { withInstall } from '@vuesax-plus/utils'
import Table from './src/table.vue'

export const VsTable = withInstall(Table)
export default VsTable

export * from './src/table'
